import { Duration, WrapperEntitySelector } from '@components/Inputs';
import { IconTooltip } from '@components/Outputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { Grid, Switch, Typography } from '@ts/storybook';
import { CEGRNoChangeStatus, IForm } from '@ts/ui-models';
import { useState } from 'react';

interface IThresholdSectionProps extends IForm {
  EGR: CEGRNoChangeStatus;
}

const ThresholdSection = (props: IThresholdSectionProps) => {
  const { EGR, mode, onCallbackChange, requiredFields } = props;
  const [enabled, setEnabled] = useState(Boolean(EGR.timeoutConfig?.thresholdTriggerDelay));
  const isReadOnly = mode === 'view';

  const onChangeTimeConfig = entityName => entity => {
    const copyTimeOut = { ...EGR.timeoutConfig };
    copyTimeOut[entityName] = entity;
    onCallbackChange('timeoutConfig')(copyTimeOut);
  };

  return (
    <Grid container direction={'column'} spacing={2}>
      <Grid container direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
        <Typography variant="body1" text={['Threshold Event', ' (', 'optional', ')']} />
        <Switch
          rightLabel={<IconTooltip withoutMargin text="thresholdEventTooltip" />}
          checked={enabled}
          onChangeValue={setEnabled}
          isReadOnly={isReadOnly}
        />
      </Grid>

      {enabled && (
        <>
          <Grid container direction={'row'} spacing={2} sx={{ alignItems: 'flex-end' }}>
            <Typography variant="body1" text="After" className="pb-2" />
            <Duration
              value={EGR.timeoutConfig?.thresholdTriggerDelay || 0}
              onChange={onChangeTimeConfig('thresholdTriggerDelay')}
              isReadOnly={isReadOnly}
              error={requiredFields.includes('timeoutConfig.thresholdTriggerDelay')}
            />
            <Typography variant="body1" text={['period', ', ', 'generate event']} className="pb-2" />
            <Grid size="grow" className="pl-2">
              <WrapperEntitySelector
                label="Event to generate in threshold"
                searchComponent={generateSearchEntitySelector('eventType')}
                value={EGR.thresholdEventTypeId}
                onChange={onCallbackChange('thresholdEventTypeId')}
                required={requiredFields.includes('thresholdEventTypeId')}
                isReadOnly={isReadOnly}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ThresholdSection;
